import React from "react";
import {Props} from "./interface";
import {Checkbox as CheckboxMui} from "@mui/material";
import {FormControlLabel, FormGroup} from "@mui/material";
import ValidationError from "../../../UI/ValidationError/ValidationError";
import FlowReferences from "../../../../flow-references";
import useDataPayload, {RefDataType} from "../../../../hooks/use-data-payload/use-data-payload";

const Checkbox = React.forwardRef<RefDataType<string>, Props>((props, ref) => {


    /*-------------------------------------
     *              HOOKS
     * ----------------------------------*/

    /************************************
     *   SET & GET VALIDATION AND STATES
     * *********************************/
    const {state, validation} = useDataPayload<string>({
        ref,
        config: props.config, setConfig: props.setConfig,
        defaultValue:""
    })
    const {config} = props


    /*-------------------------------------
     *             FUNCTIONS
     * ----------------------------------*/
    const addItemHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        state.set(e.target.checked ? '1' : '0');
        validation.clear()
    }


    return (
        <div>
            <FormGroup>
                <FormControlLabel
                    control={
                        <CheckboxMui
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => addItemHandler(e)}
                            checked={state.value === '1'}
                        />
                    }
                    label={config.text.locale}
                    value={state.value === '1'}
                />
            </FormGroup>
            <ValidationError validation={validation}/>
        </div>
    )
})

export default Checkbox